import http from './httpService'
import apiUrl from '../configs/api'

const apiEndpoint = `${apiUrl}/history`

export function getHistoryByEventId(eventId,payload) {
    return http.get(`${apiEndpoint}/event/${eventId}`,{params: payload})
}
  